import { Component, Input } from '@angular/core';

@Component({
  selector: 'ig-audio-player',
  templateUrl: './audio.player.component.html',
  styleUrl: './audio.player.component.scss',
})
export class AudioPlayerComponent {
  @Input() public audio: {
    isActive: boolean;
    link: string;
    description: string;
  };

  @Input() textColor = 'text-gray-200';

  /**
   * Prevent click events from bubbling up to parent containers
   * This ensures audio player interactions don't trigger POI click handlers
   */
  onAudioPlayerClick(event: Event): void {
    event.stopPropagation();
    // Don't prevent default to allow normal audio controls functionality
  }
}
